export default {"src":"/_next/static/media/github.66c5db05.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};